'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleAttachmentUploadProgress = undefined;

var _fileUploadsConstants = require('../constants/fileUploadsConstants');

var _attachmentUploadProgress = require('../../file-uploads/actions/attachmentUploadProgress');

var handleAttachmentUploadProgress = exports.handleAttachmentUploadProgress = function handleAttachmentUploadProgress(_ref) {
  var localId = _ref.localId,
      threadId = _ref.threadId,
      loaded = _ref.loaded,
      total = _ref.total;
  return function (dispatch) {
    var actualProgress = loaded / total;

    var cappedProgressPercentage = actualProgress * _fileUploadsConstants.MAX_UPLOAD_PROGRESS_PERCENTAGE;

    dispatch((0, _attachmentUploadProgress.attachmentUploadProgress)({
      localId: localId,
      threadId: threadId,
      progress: cappedProgressPercentage
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/handleAttachmentUploadProgress.js
// module id = 562
// module chunks = 2 3